import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useDataCenterType() {
  const [t] = useTranslation(['projects']);

  const options = useMemo(
    () => [
      { label: 'Colocated', value: 'colocated' as const },
      { label: 'Hyperscale', value: 'hyperscale' as const },
      { label: 'AI', value: 'ai' as const },
      { label: 'Other', value: 'other' as const },
    ],
    [t]
  );

  const kv = useMemo(
    () => options.reduce((map, option) => ({ ...map, [option.value]: option.label }), {}) as Record<string, string>,
    [options]
  );

  const map = useCallback((value?: string | null) => (value ? kv[value] : null), [kv]);

  return { options, kv, map };
}
